import * as yup from 'yup';

const schema = yup.object({
  name: yup.string().required(),
  email: yup.string().email().notRequired().nullable(),
  mobile: yup.string().notRequired().nullable(),
});

export default schema;
